// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"9d829f4f","36":"dc7d5310","654":"dbbf8ac2","954":"e2f1145f","956":"5212e116"}[chunkId] + ".chunk.css";
};